import Vue from 'vue';
import App from './App.vue';
import router from './router.js';
import store from './store.js';
import firebase from 'firebase';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import CoreuiVue from '@coreui/vue';
import { iconsSet as icons } from './assets/icons/icons.js';
import VueMobileDetection from 'vue-mobile-detection';
import VueTelInput from 'vue-tel-input'


import "@coreui/coreui/dist/css/coreui.min.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.min.css';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(CoreuiVue);
Vue.use(VueMobileDetection);
Vue.use(VueTelInput)


Vue.config.productionTip = false

let app = '';

var firebaseConfig = {
  apiKey: "AIzaSyAUFbTasBKIWJIrFUqRcqDd2bYHHqmZ2NQ",
  authDomain: "aumhum-e45f3.firebaseapp.com",
  databaseURL: "https://aumhum-e45f3.firebaseio.com",
  projectId: "aumhum-e45f3",
  storageBucket: "aumhum-e45f3.appspot.com",
  messagingSenderId: "75080491693",
  appId: "1:75080491693:web:61f2acf1ecbff5c51f9c24",
  measurementId: "G-5MNTMYMR46"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
//firebase.analytics();

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      icons,
      render: h => h(App)
    }).$mount('#app')
  }
});